import { computed } from 'vue'

import type { WritableComputedRef } from 'vue'

import { useTasksKanbanStore } from './store'

interface TaskCommentsReturn {
  placeholder: string
  refComment: WritableComputedRef<string>
}

export const useTaskComments = (): TaskCommentsReturn => {
  const tasksKanbanStore = useTasksKanbanStore()
  const placeholder = 'Type details of the task: client\'s request, deadlines, details that are important for the task resolution'

  const refComment = computed<string>({
    get: () => tasksKanbanStore.getComment ?? '',
    set: (value) => {
      tasksKanbanStore.setComment(value ? value : null)
    },
  })

  return {
    refComment,
    placeholder,
  }
}
